import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-posting-cell',
  templateUrl: './posting-cell.component.html',
  styleUrls: ['./posting-cell.component.scss']
})
export class PostingCellComponent implements OnInit {
    @Input() posting: any;
    @Input() prepayment = false;

    constructor() { }

    ngOnInit(): void {
    }

    get postingCellClass() {
        return `posting-purpose-${this.posting?.purpose} ${this.posting?.closed ? 'posting-cell-closed' : 'posting-cell-open'}`;
    }

    get postingAmount() {
        if(this.posting?.amount == null) return '-';
        return this.posting?.amount?.toLocaleString('en');
    }

    get getPostingTitle() {
        switch(this.posting?.purpose){
            case 'AutomatedAdjustment':
                return 'Automated depreciation';
            case 'ManualAdjustment':
                if(this.prepayment) {
                    return 'Manual adjustment';
                }
                return 'Manual depreciation';
            case 'Disposal':
                return 'Asset disposal';
            case 'DisposalReversal' :
                return 'Reversal of asset disposal';
            case 'DeletionInYear':
                return 'Asset deletion in year';
            case 'DeletionPriorYears':
                return 'Asset deletion prior year';
            case 'Deletion':
                return 'Item deletion';
            case 'DeletionReversal':
                return 'Reversal of deletion';
            case 'AutomatedAccrual':
                return 'Automated accrual';
            case 'ManualAccrual':
                return 'Manual accrual';
            case 'ManualRelease':
                return 'Manual release';
            case 'AutomatedRelease':
                return 'Automated release';
            case 'Repayment':
                return 'Loan repayment';
            case 'InterestAccrued':
                return 'Interest charge';
            case 'PrincipalPayment':
                return 'Principal payment';
            case 'AssetBalanceSheet':
                return 'Asset balance sheet entry';
            case 'AssetBalanceDeletion':
                return 'Asset balance deletion';
            case 'AssetBalanceDeletionReversal':
                return 'Reversal of asset balance deletion';
            case 'AssetDepreciation':
                return 'Lease Asset depreciation';
            default:
                return '';
        }
    }
}
